@if (prettyRule | async; as rule) {
  @if (rule.rules.length) {
    <div class="rule" [ngClass]="{ 'border': border }">
      @for (childRule of rule.rules; track childRule; let i = $index) {
        <div>
          <ng-container>
            @if (!childRule.condition) {
              <span class="bolder">{{ (orderFieldMap || (fieldMap | async))[childRule.field]?.name }}</span>
              <span class="operator">{{ (operatorLabels[childRule.operator] ? (operatorLabels[childRule.operator] | translate) : childRule.operator) | uppercase }}</span>
              <div class="bolder value">
                {{ childRule.displayValue.display }}
                @if (childRule.displayValue.otherCount) {
                  <span
                    class="popover-btn"
                    [mdePopoverTriggerFor]="other">
                    {{ 'CONTROLS.more_values' | translate: { count: childRule.displayValue.otherCount } }}
                  </span>
                }
              </div>
              @if (rule.rules.length !== i + 1) {
                <b class="union">{{ (rule.condition === 'and' ? 'QUERY_BUILDER.and' : 'QUERY_BUILDER.or') | translate | uppercase }}</b>
              }
            } @else {
              <app-rule-view [rule]="childRule" [orderFieldMap]="orderFieldMap"></app-rule-view>
              @if (rule.rules.length !== i + 1) {
                <b class="union">{{ (rule.condition === 'and' ? 'QUERY_BUILDER.and' : 'QUERY_BUILDER.or') | translate | uppercase }}</b>
              }
            }
          </ng-container>
          <mde-popover #other="mdePopover" mdePopoverTriggerOn="click"
            mdePopoverPositionY="below"
            [mdePopoverCloseOnClick]="false"
            [mdePopoverOverlapTrigger]="false">
            <app-layout [columnCount]="12">
              <app-layout-content>
                <div class="content">
                  {{ childRule.displayValue?.other }}
                </div>
              </app-layout-content>
            </app-layout>
          </mde-popover>
        </div>
      }
    </div>
  }
}
